import { IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Geocoding } from 'shared/geo/GeoHelpers';
import { joinStrings } from 'shared/utils/StringUtils';
import { ColorDynamic } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import styled from 'styled-components';

const Root = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  padding: 8px 4px 8px 8px;
  border-radius: 4px;
  background-color: ${ColorDynamic.Silver30};
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

const SuggestionText = styled(Typography)`
  flex: 1;
`;

interface AddressVerificationCardProps {
  suggestion: Geocoding;
  onAccept: () => void;
  onDismiss: () => void;
}

export function AddressVerificationCard({
  suggestion,
  onAccept,
  onDismiss,
}: AddressVerificationCardProps) {
  const street = joinStrings(' ', suggestion.house_number, suggestion.address);
  const formattedAddress = joinStrings(
    ', ',
    street,
    suggestion.place,
    suggestion.region_short,
    suggestion.postcode,
  );

  return (
    <Root>
      <SuggestionText variant="body2">
        Did you mean <strong>{formattedAddress}</strong>?
      </SuggestionText>
      <Actions>
        <Button size="small" variant="neutral" onClick={onAccept}>
          Update
        </Button>
        <IconButton
          size="small"
          onClick={onDismiss}
          aria-label="Dismiss suggestion"
        >
          <Close fontSize="small" />
        </IconButton>
      </Actions>
    </Root>
  );
}
